import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EventsListPage } from './events-list.page';
import { PagesModule } from '../../pages.module';

const routes: Routes = [
  {
    path: '',
    component: EventsListPage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [EventsListPage]
})
export class EventsListPageModule {}
